<div *ngIf="isLoading" class="loading-area-lg">
  <app-loading></app-loading>
</div>

<main id="register-fav" class="container" [class.d-none]="isLoading">
  <div class="bookmark-caption text-center">このページをブラウザで<br><span class="book">ブックマーク登録</span>をしてください</div>
  <img id="bookmark-icon" class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/bookmark-star.gif">
  <p class="bookmark-caption text-center mt-2">登録したページをブックマークから訪問すると、自動サインインされます</p>

  <ul id="browser-tabs" class="nav nav-tabs flex-column mb-4 align-content-center">
    <li class="nav-item nav-item-border">
      <a href="#chromeios-tab" class="nav-link" data-toggle="tab">Chrome<span class="medium-text">(iOS)をご利用の方</span></a>
    </li>
    <li class="nav-item nav-item-border">
      <a href="#chrome-tab" class="nav-link" data-toggle="tab">Chrome<span class="medium-text">(Android)をご利用の方</span></a>
    </li>
    <li class="nav-item nav-item-border">
      <a href="#safari-tab" class="nav-link" data-toggle="tab">Safariをご利用の方</a>
    </li>
  </ul>

  <div class="tab-content bg-light rounded p-3 mt-4">

    <div class="tab-pane fade show active" id="chromeios-tab">
      <h2 class="browser-title chrome-title">Chrome(iOS)をご利用の方</h2>
      <p class="browser-warning mb-4">※画面はChormeバージョン81のものです</p>
      <ul class="list-unstyled browser-caption mt-2">
        <li class="mt-3"><span class="number-color">①</span>Chormeでこのページを開き、画面右上の<span class="share-icon">共有ボタン</span>をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/chromeiosoperation-1.gif">
          </li>
        <li class="mt-4"><span class="number-color">②</span>メニュー一覧から「お気に入りに追加」をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/chromeiosoperation-2.gif">
          </li>
        <li class="my-4"><span class="number-color">③</span>「ブックマークしました」のメッセージが表示されたら、完了です</li>
      </ul>
    </div>

    <div class="tab-pane fade" id="chrome-tab">
      <h2 class="browser-title chrome-title">Chrome(Android)をご利用の方</h2>
      <p class="browser-warning mb-4">※画面はChormeバージョン81のものです</p>
      <ul class="list-unstyled browser-caption mt-2">
        <li class="mt-3"><span class="number-color">①</span>Chormeでこのページを開き、画面右上の<span id="menu-icon">メニューアイコン</span>をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/chromeoperation-1.gif">
          </li>
        <li class="mt-4"><span class="number-color">②</span>メニュー一覧から☆をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/chromeoperation-2.gif">
          </li>
        <li class="my-4"><span class="number-color">③</span>「ブックマークしました」のメッセージが表示されたら、完了です</li>
      </ul>
    </div>

    <div class="tab-pane fade" id="safari-tab">
      <h2 class="browser-title safari-title">Safariをご利用の方</h2>
      <p class="browser-warning mb-4">※画面はSafariバージョン13のものです</p>
      <ul class="list-unstyled browser-caption">
        <li class="mt-3"><span class="number-color">①</span>Safariでこのページを開き、画面下の<span class="share-icon">共有ボタン</span>をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/safarioperation-1.gif">
          </li>
        <li class="mt-4"><span class="number-color">②</span>メニュー一覧から「ブックマークに追加」をタップします
          <img class="img-fluid mx-auto d-block mt-2" src="../../../assets/images/safarioperation-2.gif">
          </li>
        <li class="mt-4"><span class="number-color">③</span>「保存」をタップで、登録完了です
          <img class="img-fluid mx-auto d-block mt-2 mb-4" src="../../../assets/images/safarioperation-3.gif">
        　</li>
      </ul>
    </div>
  </div>

  <div class="text-center">
    <button class="btn btn-secondary mt-4 mb-2" (click)="close()">このウィンドウを閉じる</button>
  </div>
</main>
